import { initCompaniesMarquee } from '../../components/companies-marquee';
import { initAcquireCard } from './acuire-cards.js';

// init companies companies_logos
initCompaniesMarquee();

initAcquireCard();
